/* globals cpac, WindowManager */

if (typeof cpac !== 'undefined') {
  cpac.errorMessage = function (message) {
    var errWin = new WindowManager({
      className: 'alphacube',
      title: 'Warning!',
      width: 430,
      height: 90,
      closable: true,
      resizable: false,
      minimizable: false,
      maximizable: false,
      destroyOnClose: true
    });
  
    errWin.win.setHTMLContent('<div class="messages">' + message + '</div>');
    errWin.win.showCenter(true);
    setTimeout('errWin.win.updateHeight()', 300);
          return errWin.win;
  }
  
}